import LojaModel from "./LojaModel";

export default class LojaDistanciaModel {
  public loja: LojaModel = new LojaModel();
  public distancia: number = 0;
  public delivery: boolean = false;

  public static sort(l1: LojaDistanciaModel, l2: LojaDistanciaModel) {
    if (l1.distancia < l2.distancia) {
      return -1;
    }
    if (l1.distancia > l2.distancia) {
      return 1;
    }
    return 0;
  }
}
